import React, { useContext, useMemo } from "react";
import FormContext from "../../../context/FormContext";
import Select from "./fields/Select";
import Input from "./fields/Input";
import DatePicker from "./fields/datePicker";
import Password from "./fields/password";
import Area from "./fields/area";
import {
  AREA,
  AUTOCOMPLETE,
  AUTOCOMPLETE_AREA,
  DATE_PICKER,
  NUMBER,
  PASSWORD,
  SELECT,
  SELECT_WITH_NEW_ITEM,
} from "../../../constants/fields";
import Number from "./fields/number";
import SelectWithNewItem from "./fields/SelectWithNewItem";
import { Option } from "./Interfaces";
import Autocomplete from "./fields/autocomplete";

interface Props {
  name: string;
  options?: Option[];
}

const Field: React.FC<Props> = ({ name, options }) => {
  const { config, errors } = useContext(FormContext);

  const fieldConfig = useMemo(() => {
    return config[name];
  }, [config, name]);

  if (!fieldConfig) {
    return null;
  }

  if (fieldConfig.type === SELECT) {
    if (options) {
      fieldConfig.options = options;
    }

    return <Select name={name} config={fieldConfig} />;
  }

  if (fieldConfig.type === DATE_PICKER) {
    return <DatePicker name={name} config={fieldConfig} />;
  }

  if (fieldConfig.type === NUMBER) {
    return <Number name={name} config={fieldConfig} />;
  }

  if (fieldConfig.type === SELECT_WITH_NEW_ITEM) {
    return <SelectWithNewItem name={name} config={fieldConfig} />;
  }

  if (fieldConfig.type === PASSWORD) {
    return (
      <Password
        name={name}
        config={fieldConfig}
        {...(errors[name]
          ? {
              help: errors[name],
              validateStatus: "error",
            }
          : {})}
      />
    );
  }

  if (fieldConfig.type === AUTOCOMPLETE) {
    return <Autocomplete name={name} config={fieldConfig} />;
  }

  if (fieldConfig.type === AUTOCOMPLETE_AREA) {
    return <Autocomplete name={name} config={fieldConfig} textarea />;
  }

  if (fieldConfig.type === AREA) {
    return <Area name={name} config={fieldConfig} />;
  }

  return (
    <Input
      name={name}
      config={fieldConfig}
      {...(errors[name]
        ? {
            help: errors[name],
            validateStatus: "error",
          }
        : {})}
    />
  );
};

export default Field;
